module.exports = __webpack_public_path__ + "static/media/intake-follow-up-and-outcomes-questionnaires-03@2x.61f1cfdf.png";